import { createVuetify, ThemeDefinition } from 'vuetify';
import 'vuetify/styles';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import { no } from 'vuetify/locale';

const customTheme: ThemeDefinition = {
    dark: false,
    colors: {
        primary: '#333F48',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    }
};

const customNo = {
    ...no,
    dataFooter: {
        pageText: '{0}-{1} av {2}',
        itemsPerPageText: 'Elementer per side:',
        itemsPerPageAll: 'Alle',
        nextPage: 'Neste side',
        prevPage: 'Forrige side',
        firstPage: 'Første side',
        lastPage: 'Siste side'
    }
};

export default createVuetify({
    theme: {
        defaultTheme: 'customTheme',
        themes: {
            customTheme
        }
    },
    locale: {
        locale: 'no',
        messages: { no: customNo }
    },
    icons: {
        defaultSet: 'mdi',
        sets: {}
    }
});
